<!-- <app-nourish-questionnaire-prompt-modal
  [isOpen]="show.reportNourishQuiz"
  [reportType]="'NUTRIGENETIC'"
></app-nourish-questionnaire-prompt-modal> -->

<app-skin-prompt-modal
  [(isOpen)]="show.reportSkinFaceScan"
></app-skin-prompt-modal>

<app-questionnaire-quick-modal-processed-modal
  [reportType]="'NUTRIGENETIC'"
  [(isOpen)]="show.reportNourishQuizCompleted"
></app-questionnaire-quick-modal-processed-modal>

<!-- Avatar Notification Modal -->
<app-avatar-notification-modal
  [isOpen]="show.avatarModalOpen"
  (isOpenChange)="handleAvatarModalClose()"
></app-avatar-notification-modal>

<!-- Questions Journal Modal -->
@if (show.questionsJournalModalOpen) {
  <app-questions-journal-modal
    [(open)]="show.questionsJournalModalOpen"
    (closeModal)="closeQuestionnaireJournalModal()"
  ></app-questions-journal-modal>
}
